import { useRef } from 'react';
import { useIsomorphicEffect } from './useIsomorphicEffect';
/**
 * It is used to store identity of value(mostly used for callback function) in ref and use the fact
 * that if identity of function changed then ref.current
 * was updated but as ref remain contant thus dependent
 * doesn't have to render bcz of changed in identity
 * aslo as we pick new identity always thereby we make sure
 * that this new identity has closure over new set of
 * variable for this render duration
 * */

export const useLatestRef = <Value>(value: Value) => {
  const valueRef = useRef<Value>(value);
  useIsomorphicEffect(() => {
    valueRef.current = value;
  }, [value]);
  return valueRef;
};
